<div class="w-full h-screen grid place-items-center place-content-center gap-4">
  <h1 class="text-title-1-desktop">Something went wrong.</h1>
  <p class="text-body-1-desktop">Page not found. Please try again later.</p>
</div>
